"use strict";

import { CDN } from '@autoguru/global-configs';
import { Box, Heading, Stack } from '@autoguru/overdrive';
import { NextPicture } from '@autoguru/picture';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const HeadingSection = ({
  title: _title = '',
  align: _align = 'center',
  alignItems: _alignItems = 'center',
  size: _size = '8',
  colour
}) => /*#__PURE__*/_jsxs(Stack, {
  space: "4",
  alignItems: _alignItems,
  children: [/*#__PURE__*/_jsx(Heading, {
    as: "h2",
    size: _size,
    align: _align,
    colour: colour ? colour : 'dark',
    children: _title
  }), /*#__PURE__*/_jsx(Box, {
    children: /*#__PURE__*/_jsx(NextPicture, {
      lazy: true,
      backgroundColor: "transparent",
      altText: "arc",
      sizes: "240px",
      width: 60,
      height: "auto",
      aspectRatio: 75 / 25,
      src: `${CDN}/images/booking-guru/landing/arc.svg`
    })
  })]
});